import { useCallback, useEffect, Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

// local imports
import lactationIcon from 'assets/icons/baby-gray.svg'
import { IFilteredLactationRoomList } from 'types/LactationType'
import { InputWrapper, StyledInputText } from './styled'

interface ILactationSearchProps {
  rooms: IFilteredLactationRoomList[] | []
  setSearchText: Dispatch<SetStateAction<string>>
  setData: Dispatch<SetStateAction<IFilteredLactationRoomList[] | []>>
  searchText: string
}

export default function LactationRoomSearch({ rooms, setData, searchText, setSearchText }: ILactationSearchProps) {
  const { t } = useTranslation()

  // Handle change event of search input
  const handleChange = (value: string) => {
    setSearchText(value)
    filterData(value)
  }

  // Filter rooms by search text
  const filterData = useCallback(
    (value: string) => {
      const includeColumns = ['name']
      const lowercasedValue = value.toLowerCase().trim()
      if (lowercasedValue === '') setData(rooms)
      else {
        const filteredData = rooms?.filter((item: IFilteredLactationRoomList) => {
          return Object.keys(item).some((key) =>
            includeColumns.includes(key)
              ? item[key as keyof IFilteredLactationRoomList].toString().toLowerCase().includes(lowercasedValue)
              : false
          )
        })
        setData(filteredData)
      }
    },
    [rooms, setData]
  )

  useEffect(() => {
    filterData(searchText)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rooms])

  const disabled = !rooms?.length

  return (
    <InputWrapper className="p-input-icon-left">
      <img src={lactationIcon} alt="lactation-room-search" className="input-icon" width={20} height={20} />
      <StyledInputText
        id="lactation-room-search"
        disabled={disabled}
        value={searchText}
        onChange={(e) => handleChange(e.target.value)}
        placeholder={t('input-texts.search-lactation-room')}
      />
    </InputWrapper>
  )
}
